module.exports = __webpack_public_path__ + "img/26.b1718c1a.jpg";